import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-btn {
    color: ${({ theme }) => theme.colors.white};
  }
  .ant-btn:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: transparent;
  }
`;
